import { setMemoizedInfo } from 'hub-http/userInfo-state';
// This is a public, unauthenticated app (quartz `auth: 'none'`), so the
// framework never loads `userInfo` and the `userInfo` promise never resolves.
// We reuse components from `recording-review-components-lib` (e.g. the media
// player and transcript) that were built for the authenticated app and call
// `userInfoSync()` from `hub-http/userInfo` to resolve gates/scopes. Without a
// memoized value, those synchronous calls throw and get logged to PROD as
// "userInfoSync failed in auth.ts when resolving gates".
//
// Priming an empty, anonymous `UserInfo` lets those gate/scope checks resolve
// to an empty set (i.e. nothing ungated) instead of throwing, which is the
// correct behavior for an unauthenticated viewer.
export const PUBLIC_USER_INFO = {
  user: {
    user_id: -1,
    email: '',
    emails: [],
    first_name: '',
    last_name: '',
    created_at: 0,
    locale: 'en-us',
    lang_enabled: false,
    partner: false,
    roles: [],
    scopes: [],
    teams: [],
    verified: false
  },
  portal: {
    portal_id: -1,
    created_at: 0,
    enabled_gates: [],
    expired: false,
    expired_at: null,
    family_id: -1,
    friends_and_family: false,
    limits: {},
    partner: false,
    product_id: -1,
    product_type: 'public',
    timezone: {
      id: 'UTC',
      offset: 0,
      'moment-data': 'UTC'
    },
    trial: false
  },
  gates: []
};
export function primePublicUserInfo() {
  setMemoizedInfo(PUBLIC_USER_INFO);
}